import headshot from './assets/headshot.jpg';
import downloadicon from './assets/download-icon.svg';
import resume from './assets/resume.pdf';
import meleetrack from './assets/meleetrack.png';
import phobgcc from './assets/phobgcc.png';
import capstone from './assets/capstoneproject.mp4';
import presentation from './assets/presentation.pdf';
import email from './assets/email-logo.svg';
import github from './assets/github-logo.svg';
import linkedin from './assets/linkedin-logo.svg';
import smash from './assets/smash-logo.svg';
import downarrow from './assets/down-arrow.svg';

import './App.css';
import Navbar from './Navbar';

const downloadResume = () => {
  var link = document.getElementById("download-link");
  link.click();
}

function App() {
  const scrollToTop = () => {
    document.getElementById("root").scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div className="App">
      <div>
        <Navbar></Navbar>
      </div>
      <header className="App-header">
        <div className="main-header-container header-container">
          <img src={headshot} className="headshot-img" alt="headshot"/>
          <div className="header-information">
            <header className="header-title">
              Justin Carew
            </header>
            <p className="header-subtitle">
              Software Engineer based in NJ/NY with proficiency in agile full-stack development
            </p>
            <a id="download-link" href={resume} target="_blank" download="resume.pdf" rel="noopener noreferrer"> </a>
            <button className="resume-button" onClick={downloadResume}>
                <div className="resume-button-container">
                  Full Resume
                  <img className="icon" src={downloadicon} alt="download icon"/>
                </div>
              </button>
          </div>
        </div>
        <img className="down-arrow icon" src={downarrow} alt="down arrow"/>
      </header>
      <header className="App-header" id="aboutme">
        <div className="header-container">
          <div className="header-information">
            <header className="header-title">
              About Me
            </header>
            <ul className="header-subtitle">
                <li>2+ years of work experience with HTML/JavaScript/CSS, Python (Pandas), Microsoft SQL Server, and REST APIs</li>
                <li>Creator of <a target="_blank" rel="noreferrer" className="main-link" href="https://meleetrack.onrender.com/">meleetrack</a>, a Node.js/SQLite web app that accurately evaluates skill level of SSBM competitors based on tournament results</li>
                <li>Project experience in C#, Java, C++, React, and Git</li>
                <li>Hobbies include creating music, learning languages, writing, cooking, and traveling</li>
              </ul>  
          </div>
        </div>
      </header>
      <header className="App-header" id="projects">
        <div className="header-container">
          <div className="header-information">
            <header className="header-title">
              Projects
            </header>
            <div className="header-subtitle project-header">
              <div className="project-header-outer-container">
                <div className="project-header-container">
                  <p className="project-title">meleetrack</p>
                  <p className="project-header-body">Full-stack Node.js/SQLite web app that allows users to search Smash Bros. Melee competitors and generate a unique graphic of the player and a description based on their stats.
                  The website was deployed using Render and can be found <a target="_blank" rel="noreferrer" className="main-link" href="https://meleetrack.onrender.com/">here</a>.</p>
                </div>
              </div>
              <div className="project-header-outer-container">
                <div className="project-header-container">
                  <p className="project-title">Capstone Agricultural Drone</p>
                  <p className="project-header-body">Multi-functional RC quadcopter drone with frame, motors, and electrical boards manually assembled. Contains a fire detection module, pesticide dispenser, and a soil moisture module: all of which programmed with Arduino IDE. The capstone group presentation poster can be found <a target="_blank" rel="noreferrer" className="main-link" href={presentation}>here</a>.</p>
                  </div>
                </div>
                <div className="project-header-outer-container">
                  <div className="project-header-container">
                    <p className="project-title">PhobGCC 1.2</p>
                    <p className="project-header-body">Custom motherboard for Nintendo Gamecube controller that solves inherent potentiometer oddity degradation effect (PODE) issues in OEM hardware by replacing potentiometers with magnets and programmed Hall effect sensors. Documentation of this project can be found <a target="_blank" rel="noreferrer" className="main-link" href="https://github.com/PhobGCC/PhobGCC-doc">here</a>.</p>
                  </div>
                </div>
              </div>  
          </div>
        </div>
        <div className="project-media-container">
          <div className="project-media-inner-container">
            <img src={meleetrack} alt="details screen of meleetrack website" className="project-image"/>
          </div>
          <div className="project-media-inner-container">
            <video className="project-image" loop autoPlay muted>
              <source src={capstone} type="video/mp4"/>
            </video>
          </div>
          <div className="project-media-inner-container">
            <img src={phobgcc} alt="gamecube controller using PhobGCC" className="project-image"/>
          </div>
        </div>
      </header>
      <header className="App-header" id="contact">
        <div className="header-container">
          <div className="header-information">
            <header className="header-title">
              Contact/Links
            </header>
            <div className="contact-container">
              <div className="contact">
                <img className="icon" src={linkedin} alt="LinkedIn symbol"/>
                <p className="header-subtitle">
                  <a target="_blank" rel="noreferrer" className="main-link" href="https://www.linkedin.com/in/justindcarew/">LinkedIn</a>
                </p>
              </div>
              <div className="contact">
                <img className="icon" src={github} alt="GitHub symbol"/>
                <p className="header-subtitle">
                <a target="_blank" rel="noreferrer" className="main-link" href="https://github.com/justincarew">GitHub</a>
                </p>
              </div>
              <div className="contact">
                <img className="icon" src={email} alt="email symbol"/>
                <p className="header-subtitle">
                <a target="_blank" rel="noreferrer" className="main-link" href="mailto:justindcarew@gmail.com">justindcarew@gmail.com</a>
                </p>
              </div>
              <div className="contact">
                <img className="icon" src={smash} alt="Super Smash Bros. symbol"/>
                <p className="header-subtitle">
                <a target="_blank" rel="noreferrer" className="main-link" href="https://meleetrack.onrender.com/">meleetrack</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <button className="resume-button" onClick={scrollToTop}>
          <div className="resume-button-container">
            Scroll to Top
          </div>
        </button>
      </header>
    </div>
  );
}

export default App;
